import {INCOME_TYPE} from '../constants/income';
import {SIZE_RECRUITMENT_TEXTURE_KEYS} from './sizeRecruitmentMarker';

/**
 * ПЛАШКА ДОХОДА на руднике, руинах, гильдии и храме: тот же шестигранный медальон,
 * что у докупки размера (configs/sizeRecruitmentMarker), с числом и иконкой
 * ресурса. Монеты — золотой медальон, очки — серебряный.
 *
 * Рисует scenes/incomeMarker. Размеры — доли размера ячейки.
 */
export const INCOME_MARKER = {
  plateSizeFactor: 1.5,
  textX: -0.27,
  textScale: 0.46,
  iconX: 0.24,
  coinsIconY: 0.05,
  iconScale: 0.062,
  // Постоянный слой дышит медленнее и тише маркера докупки: плашек на поле много
  halo: {
    sizeFactor: 2.15,
    minAlpha: 0.4,
    maxAlpha: 0.85,
    minScale: 0.96,
    maxScale: 1.05,
    pulseMs: 1400,
  },
  themes: {
    [INCOME_TYPE.COINS]: {
      plateKey: SIZE_RECRUITMENT_TEXTURE_KEYS.PLATE,
      haloTint: 0xffb81f,
      textTintTop: 0xfff3c0,
      textTintBottom: 0xffb81f,
    },
    [INCOME_TYPE.WIN_POINTS]: {
      plateKey: SIZE_RECRUITMENT_TEXTURE_KEYS.PLATE_SILVER,
      haloTint: 0xc4d6f5,
      textTintTop: 0xffffff,
      textTintBottom: 0xb7c6dc,
    },
  },
  // Точка заблокирована противником: дохода нет, медальон потух, число красное
  blocked: {plateTint: 0x8a8a8a, iconTint: 0xb5b5b5, textColor: '#ff3a2e'},
  // Разовый показ: медальон выпрыгивает
  popFromScale: 0.7,
  popMs: 320,
};
